import { TableColumnPopupType } from "../../../Constants/Constants";
import { getIsShowTableColumn } from "../../../Utilities/Utility";

export class StockRequestTableWidth {
    isLineNumberVisible: boolean;
    isCodeVisible: boolean;
    isNameVisible: boolean;
    isDescriptionVisible: boolean;
    isNameWithDescriptionVisible: boolean;
    isQuantityVisible: boolean;
    isTargetWarehouseNameVisible: boolean;
    isTargetWarehouseCodeVisible: boolean;
    isSelectedRowVisible: boolean;
    isSelectedRackVisible: boolean;
    isSelectedBinVisible: boolean;
    isRequestedQtyVisible: boolean;
    isUomVisible: boolean;

    isProductCustomFieldVisible: boolean; 

    lineNumber: number;
    code: number;
    name: number;
    description: number;
    nameWithDescription: number;
    quantity: number;
    targetWarehouseName: number;
    targetWarehouseCode: number;
    selectedRow: number;
    selectedRack: number;
    selectedBin: number;
    requestedQty: number;
    uom: number;

    productCustomField: number;




    originalLineNumber: number;
    originalCode: number;
    originalName: number;
    originalDescription: number;
    originalNameWithDescription: number;
    originalQuantity: number;
    originalTargetWarehouseName: number;
    originalTargetWarehouseCode: number;
    originalSelectedRow: number;
    originalSelectedRack: number;
    originalSelectedBin: number;
    originalRequestedQty: number;
    originalUom: number;

    originalProductCustomField: number;

    productCustomFieldList: any;

    constructor() {
        this.isLineNumberVisible = true
        this.isCodeVisible = true
        this.isNameVisible = true
        this.isDescriptionVisible = true
        this.isNameWithDescriptionVisible = true 
        this.isQuantityVisible = true
        this.isTargetWarehouseNameVisible = true
        this.isTargetWarehouseCodeVisible = true
        this.isSelectedRowVisible = true
        this.isSelectedRackVisible = true
        this.isSelectedBinVisible = true
        this.isRequestedQtyVisible = true
        this.isUomVisible = true
        this.isProductCustomFieldVisible = true 


        this.lineNumber = 10
        this.code = 10
        this.name = 15
        this.description = 20
        this.nameWithDescription = this.name + this.description
        this.quantity = 5
        this.targetWarehouseName = 10
        this.targetWarehouseCode = 5
        this.selectedRow = 5
        this.selectedRack = 5
        this.selectedBin = 5
        this.requestedQty = 5
        this.uom = 5
        this.productCustomField = 5

        this.originalLineNumber = 10
        this.originalCode = 10
        this.originalName = 15
        this.originalDescription = 20
        this.originalNameWithDescription = this.originalName + this.originalDescription
        this.originalQuantity = 5
        this.originalTargetWarehouseName = 10
        this.originalTargetWarehouseCode = 5
        this.originalSelectedRack = 5
        this.originalSelectedRow = 5
        this.originalSelectedBin = 5
        this.originalRequestedQty = 5
        this.originalUom = 5
        this.originalProductCustomField = 5

        this.productCustomFieldList = undefined

    }

    setIsShowWidth(columnData: any) {
        this.isLineNumberVisible = getIsShowTableColumn(columnData, TableColumnPopupType.lineNumber)
        this.isCodeVisible = getIsShowTableColumn(columnData, TableColumnPopupType.code)
        this.isNameVisible = getIsShowTableColumn(columnData, TableColumnPopupType.productName)
        this.isDescriptionVisible = getIsShowTableColumn(columnData, TableColumnPopupType.description)
        this.isNameWithDescriptionVisible = getIsShowTableColumn(columnData, TableColumnPopupType.productNameWithDescription)
        this.isProductCustomFieldVisible = getIsShowTableColumn(columnData, TableColumnPopupType.productCustomField)
        this.isQuantityVisible = getIsShowTableColumn(columnData, TableColumnPopupType.quantity)
        this.isTargetWarehouseNameVisible = getIsShowTableColumn(columnData, TableColumnPopupType.targetWarehouseName)
        this.isTargetWarehouseCodeVisible = getIsShowTableColumn(columnData, TableColumnPopupType.targetWarehouseCode)
        this.isSelectedRowVisible = getIsShowTableColumn(columnData, TableColumnPopupType.selectedRow)
        this.isSelectedRackVisible = getIsShowTableColumn(columnData, TableColumnPopupType.selectedRack)
        this.isSelectedBinVisible = getIsShowTableColumn(columnData, TableColumnPopupType.selectedBin)
        this.isRequestedQtyVisible = getIsShowTableColumn(columnData, TableColumnPopupType.requestedQty)
        this.isUomVisible = getIsShowTableColumn(columnData, TableColumnPopupType.uom)

        var width = 5
        var maxWidth = 20

        var productCustomFieldList = columnData.filter((x: any) => x.code !== undefined)
        if (productCustomFieldList.length > 0) {
            this.isProductCustomFieldVisible = false
            if (this.productCustomFieldList === undefined) {
                //assign product custom list with corresponding flag
                this.productCustomFieldList = []
                if (productCustomFieldList.length > 4) {
                    width = maxWidth / productCustomFieldList.length
                }
                productCustomFieldList.forEach((element: any) => {
                    var item = {} as any
                    item.code = element.code
                    item.isVisible = element.columnOption.isShowColumn
                    item.originalWidth = width
                    item.width = width
                    item.type = element.name
                    item.label = element.label
                    this.productCustomFieldList.push(item)
                });
            }
            else {
                this.productCustomFieldList.forEach((element: any) => {
                    var item = columnData.find((x: any) => x.code === element.code)
                    if (item !== undefined) {
                        element.isVisible = item.columnOption.isShowColumn
                    }
                });
            }
        }
    }

    getTableHeaderWidths() {
        var totalWidth = 0
        totalWidth = this.getTotalWidth(totalWidth);
        if (totalWidth === 100) {
            this.resetElementOriginalWidth();
        }
        else if (totalWidth === 0) {
            this.resetElementWidth();
        }
        else {
            var totalSelectedElement = this.getTotalSelectedElement()
            if (totalSelectedElement !== 0) {
                var totalOffset = (100 - totalWidth) / totalSelectedElement
                this.updateElementWidth(totalOffset)
            }
        }
    }

    private resetElementOriginalWidth() {
        this.lineNumber = this.originalLineNumber
        this.code = this.originalCode
        this.name = this.originalName
        this.description = this.originalDescription
        this.nameWithDescription = this.originalNameWithDescription
        this.quantity = this.originalQuantity
        this.targetWarehouseName = this.originalTargetWarehouseName
        this.targetWarehouseCode = this.originalTargetWarehouseCode
        this.selectedRow = this.originalSelectedRow
        this.selectedRack = this.originalSelectedRack
        this.selectedBin = this.originalSelectedBin
        this.requestedQty = this.originalRequestedQty
        this.uom = this.originalUom
        this.productCustomField = 5

        this.productCustomField = this.originalProductCustomField

        if (this.productCustomFieldList !== undefined) {
            this.productCustomFieldList.forEach((element: any) => {
                element.width = element.originalWidth
            });
        }
    }

    private resetElementWidth() {
        this.lineNumber = 0
        this.code = 0
        this.name = 0
        this.description = 0
        this.nameWithDescription = 0
        this.quantity = 0
        this.targetWarehouseName = 0
        this.targetWarehouseCode = 0
        this.selectedRow = 0
        this.selectedRack = 0
        this.selectedBin = 0
        this.requestedQty = 0
        this.uom = 0

        if (this.productCustomFieldList !== undefined) {
            this.productCustomFieldList.forEach((element: any) => {
                element.width = 0
            });
        }
    }

    private getTotalWidth(totalWidth: number) {
        if (this.isLineNumberVisible) {
            totalWidth += this.lineNumber;
        }
        if (this.isCodeVisible) {
            totalWidth += this.code;
        }
        if (this.isNameVisible) {
            totalWidth += this.name;
        }
        if (this.isDescriptionVisible) {
            totalWidth += this.description;
        }
        if (this.isNameWithDescriptionVisible) {
            totalWidth += this.nameWithDescription;
        }
        if (this.isQuantityVisible) {
            totalWidth += this.quantity;
        }
        if (this.isTargetWarehouseNameVisible) {
            totalWidth += this.targetWarehouseName;
        }
        if (this.isTargetWarehouseCodeVisible) {
            totalWidth += this.targetWarehouseCode;
        }
        if (this.isSelectedRowVisible) {
            totalWidth += this.selectedRow;
        }
        if (this.isSelectedRackVisible) {
            totalWidth += this.selectedRack;
        }
        if (this.isSelectedBinVisible) {
            totalWidth += this.selectedBin;
        }
        if (this.isRequestedQtyVisible) {
            totalWidth += this.requestedQty;
        }
        if (this.isUomVisible) {
            totalWidth += this.uom;
        }
        if (this.isProductCustomFieldVisible) {
            totalWidth += this.productCustomField;
        }

        if (this.productCustomFieldList !== undefined) {
            this.productCustomFieldList.forEach((element: any) => {
                if (element.isVisible) {
                    totalWidth += element.width;
                }
            });
        }

        return totalWidth;
    }

    private getTotalSelectedElement() {
        var totalSelectedElement = 0
        if (this.isLineNumberVisible) {
            totalSelectedElement += 1
        }
        if (this.isCodeVisible) {
            totalSelectedElement += 1
        }
        if (this.isNameVisible) {
            totalSelectedElement += 1
        }
        if (this.isDescriptionVisible) {
            totalSelectedElement += 1
        }
        if (this.isNameWithDescriptionVisible) {
            totalSelectedElement += 1
        }
        if (this.isQuantityVisible) {
            totalSelectedElement += 1
        }
        if (this.isTargetWarehouseNameVisible) {
            totalSelectedElement += 1
        }
        if (this.isTargetWarehouseCodeVisible) {
            totalSelectedElement += 1
        }
        if (this.isSelectedRowVisible) {
            totalSelectedElement += 1
        }
        if (this.isSelectedRackVisible) {
            totalSelectedElement += 1
        }
        if (this.isSelectedBinVisible) {
            totalSelectedElement += 1
        }
        if (this.isRequestedQtyVisible) {
            totalSelectedElement += 1
        }
        if (this.isUomVisible) {
            totalSelectedElement += 1
        }
        if (this.isProductCustomFieldVisible) {
            totalSelectedElement += 1
        }

        if (this.productCustomFieldList !== undefined) {
            this.productCustomFieldList.forEach((element: any) => {
                if (element.isVisible) {
                    totalSelectedElement += 1
                }
            });
        }

        return totalSelectedElement
    }

    private updateElementWidth(additionalWidth: number) {
        if (this.isLineNumberVisible) {
            this.lineNumber = this.originalLineNumber + additionalWidth
        }
        if (this.isCodeVisible) {
            this.code = this.originalCode + additionalWidth
        }
        if (this.isNameVisible) {
            this.name = this.originalName + additionalWidth
        }
        if (this.isDescriptionVisible) {
            this.description = this.originalDescription + additionalWidth
        }
        if (this.isNameWithDescriptionVisible) {
            this.nameWithDescription = this.originalNameWithDescription + additionalWidth
        }
        if (this.isQuantityVisible) {
            this.quantity = this.originalQuantity + additionalWidth
        }
        if (this.isTargetWarehouseNameVisible) {
            this.targetWarehouseName = this.originalTargetWarehouseName + additionalWidth
        }
        if (this.isTargetWarehouseCodeVisible) {
            this.targetWarehouseCode = this.originalTargetWarehouseCode + additionalWidth
        }
        if (this.isSelectedRowVisible) {
            this.selectedRow = this.originalSelectedRow + additionalWidth
        }
        if (this.isSelectedRackVisible) {
            this.selectedRack = this.originalSelectedRack + additionalWidth
        }
        if (this.isSelectedBinVisible) {
            this.selectedBin = this.originalSelectedBin + additionalWidth
        }
        if (this.isRequestedQtyVisible) {
            this.requestedQty = this.originalRequestedQty + additionalWidth
        }
        if (this.isUomVisible) {
            this.uom = this.originalUom + additionalWidth
        }
        if (this.isProductCustomFieldVisible) {
            this.productCustomField = this.originalProductCustomField + additionalWidth
        }

        if (this.productCustomFieldList !== undefined) {
            this.productCustomFieldList.forEach((element: any) => {
                if (element.isVisible) {
                    element.width = element.originalWidth + additionalWidth
                }
            });
        }
    }

    getProductCustomFieldWidthByCode(code: string) {
        if (Array.isArray(this.productCustomFieldList)) {
            var item = this.productCustomFieldList.find((x: any) => x.code === code)
            if (item !== undefined) {
                return item.width
            }
        }
        return undefined
    }
}